import { RightOutlined } from "@ant-design/icons";
import { Image } from "antd";
import { Card } from "antd-mobile";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AppBar, Drawer } from "../../../../components";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { useGetFacebookLink } from "../../../../hooks/facebookLink/facebookLink.hooks";
import { useGetTGBetChannelLink } from "../../../../hooks/tgBetChannelLink/tglink.hooks";
import { useGetTGChannelLink } from "../../../../hooks/tgChannelLink/tglink.hooks";
import { useGetTGLink } from "../../../../hooks/tgLink/tglink.hooks";
import { useGetWhatsappLink } from "../../../../hooks/whatsappLink/whatsappLink.hooks";
import { envChangeType } from "../../../../plugins/utils";
import cs from "../../images/cs.png";
import facebook from "../../images/fb.png";
import tg from "../../images/tg.png";
import tgBetChannel from "../../images/tg_bet.png";
import tgChannel from "../../images/tg_channel.png";
import whatsapp from "../../images/whatsapp.png";
import "./style";
import styles from "./styleModule";

const CSPopup = ({ onClose = () => {}, visible = false, destroyOnClose = false }) => {
  const { t } = useTranslation();
  const { openCSDrawer } = useLogin();
  const currency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

  const { data: tgLink } = useGetTGLink({
    options: { enabled: !!currency && visible },
  });
  const { data: tgChannelLink } = useGetTGChannelLink({
    options: { enabled: !!currency && visible },
  });
  const { data: tgBetChannelLink } = useGetTGBetChannelLink({
    options: { enabled: !!currency && visible },
  });
  const { data: facebookLink } = useGetFacebookLink({
    options: { enabled: !!currency && visible },
  });
  const { data: whatsappLink } = useGetWhatsappLink({
    options: { enabled: !!currency && visible },
  });

  const cardEnum = useMemo(() => {
    return {
      cs: {
        onClick: () => {
          openCSDrawer();
        },
        src: cs,
        name: "cs",
        title: t("normal.customerService"),
        show: !envChangeType("REACT_APP_CHATWOOT_URL"),
      },
      tg: {
        onClick: () => {
          if (!tgLink || !tgLink.data) return;
          window.open(tgLink?.data);
        },
        src: tg,
        name: "tg",
        title: t("normal.tg"),
        show: tgLink && tgLink.data && tgLink?.data !== "",
      },
      tg_channel: {
        onClick: () => {
          if (!tgChannelLink || !tgChannelLink.data) return;
          window.open(tgChannelLink?.data);
        },
        src: tgChannel,
        name: "tg_channel",
        title: t("normal.telegramChannel"),
        show: tgChannelLink && tgChannelLink.data && tgChannelLink?.data !== "",
      },
      tg_bet_channel: {
        onClick: () => {
          if (!tgBetChannelLink || !tgBetChannelLink.data) return;
          window.open(tgBetChannelLink?.data);
        },
        src: tgBetChannel,
        name: "tg_bet_channel",
        title: t("normal.tgBetChannel"),
        show: tgBetChannelLink && tgBetChannelLink.data && tgBetChannelLink?.data !== "",
      },
      facebook: {
        onClick: () => {
          if (!facebookLink || !facebookLink.data) return;
          window.open(facebookLink?.data);
        },
        src: facebook,
        name: "facebook",
        title: t("normal.facebook"),
        show: facebookLink && facebookLink.data && facebookLink?.data !== "",
      },
      whatsapp: {
        onClick: () => {
          if (!whatsappLink || !whatsappLink.data) return;
          window.open(whatsappLink?.data);
        },
        src: whatsapp,
        name: "whatsapp",
        title: t("normal.whatsapp"),
        show: whatsappLink && whatsappLink.data && whatsappLink?.data !== "",
      },
    };
  }, [tgLink, facebookLink, whatsappLink]);

  useEffect(() => {
    if (visible && tgLink?.data === "") {
      openCSDrawer();
    }
  }, [visible, tgLink]);

  const renderContent = () => {
    return (
      <div className={`${styles.csPopupContainer} cs-popup-container`}>
        <AppBar
          title={t("normal.customerService")}
          showBackButton={true}
          iconClosePadding={"4px"}
          onClickEvent={() => {
            onClose();
          }}
        />
        <div className={styles.container}>
          {Object.keys(cardEnum).map((item) => {
            return (
              cardEnum[item].show && (
                <Card
                  className={styles.card}
                  bodyStyle={{ display: "flex" }}
                  onClick={cardEnum[item].onClick}
                  key={cardEnum[item].name}
                >
                  <Image
                    src={cardEnum[item].src}
                    alt={cardEnum[item].name}
                    preview={false}
                    width={24}
                  />
                  <div className={styles.title}>{cardEnum[item].title}</div>
                  <div style={{ flex: 1 }} />
                  <div>
                    <RightOutlined className={styles.rightArray} />
                  </div>
                </Card>
              )
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <Drawer
        placement={"right"}
        isClosable={false}
        onClose={onClose}
        showDrawer={visible}
        destroyOnClose={destroyOnClose}
        width={"100%"}
        renderContent={renderContent}
      />
    </>
  );
};

export default CSPopup;
